import { createSlice } from '@reduxjs/toolkit'

function sortItems(data: any) {
  return data?.sort((a: any, b: any) => b.count - a.count)
}

export const charts = createSlice({
  name: 'charts',
  initialState: {
    positiveData: { cards: [], total: 0 },
    negativeData: { cards: [], total: 0 },
    reviewCountData: [],
    volumeData: { negatif: [], positif: [] },
    locationsData: [],
    regionData: {
      avgNote: 0, avgPositif: 0, publish: 0, pending: 0, stations: 0, avgReply: 0, avgTime: 0
    },
    regionList: [],
    stationsStats: [],
    reported: 0,
    publishedExpired: 0,
    reviewingExpired: 0
  },
  reducers: {
    setPositiveData: (state, item) => {
      state.positiveData.cards = sortItems(item.payload.cards)
      state.positiveData.total = item.payload.total
    },
    setNegativeData: (state, item) => {
      state.negativeData.cards = sortItems(item.payload.cards)
      state.negativeData.total = item.payload.total
    },
    setReviewCountData: (state, item) => {
      state.reviewCountData = item.payload
    },
    setVolumeData: (state, item) => {
      state.volumeData = { negatif: item.payload.negatif, positif: item.payload.positif }
    },
    setLocationsData: (state, item) => {
      state.locationsData = item.payload
    },
    setRegionList: (state, item) => {
      state.regionList = item.payload
    },
    setRegionData: (state, item) => {
      state.regionData = item.payload
    },
    setStationStats: (state, item) => {
      state.stationsStats = item.payload
    },
    setReviewingExpired: (state, item) => {
      state.reviewingExpired = item.payload
    },
    setPublishedExpired: (state, item) => {
      state.publishedExpired = item.payload
    },
    setReported: (state, item) => {
      state.reported = item.payload
    }
  }
})

export const { setPositiveData, setNegativeData, setReviewCountData, setVolumeData, setLocationsData, setRegionData, setRegionList, setStationStats, setReported } = charts.actions
export default charts.reducer